import translate from '@yandex-delivery/core/i18n/translate'

import {config} from './config'

const i18n = {
  print: translate(config.lang, config.i18n, 'route'),
} as const

export default i18n
